module.exports = __webpack_public_path__ + "img/content-1.1eb3363a.png";